<script setup>

import { ref, onMounted, watch } from "vue";
import ERP from "../../api/v2/ERP.mjs";
import View from "../../api/v2/View.mjs";
import UtilArray from "../../utils/UtilArray.mjs";
import OrdemDeServicoItemService from "../../api/v2/services/OrdemDeServicoItemService.js";
import RequisicaoDeCompraService from "../../api/v2/services/RequisicaoDeCompraService.js";
import RetornarItemModal from './RetornarItemModal.vue';

const compradores = ref([]);
let compradorSelecionado = ref({});

const ordemDeServicoItens = ref([]);
const ordemDeServicoItensLoading = ref(true);
let ordemDeServicoItensSelecionados = ref([]);



let jobs = ref([]);
let jobSelecionado = ref("");

let ordensDeServico = ref([]);
let ordemDeServicoSelecionada = ref("");

let palavrasChave = ref([]);
let palavraChaveSelecionada = ref("");

let buscaGeral = ref("");



const controlesDesativados = ref(false);
const retornandoItens = ref(false);
const distribuindoItens = ref(false);



const filterJob = (jobCodigo) =>{

    if (!jobSelecionado.value) {
          return true;
    }

    return jobCodigo.toLowerCase().includes(jobSelecionado.value.toLowerCase());

}

const filterOS = (osCodigo) =>{

    if (!ordemDeServicoSelecionada.value) {
        return true;
    }

    return osCodigo.toLowerCase().includes(ordemDeServicoSelecionada.value.toLowerCase());

}

let ordemDeServicoItensHeaders = [
    { text: 'Job',                          value: 'jobCodigo',                         class:"c-table__header",   cellClass:'c-table__item', filter: filterJob},
    { text: 'OS',                           value: 'osCodigo',                          class:"c-table__header",    cellClass:'c-table__item', filter: filterOS},
    { text: 'Sequência',                    value: 'sequencia',                         class:"c-table__header",    cellClass:'c-table__item', filterable: false,},
    { text: 'Código do Item',               value: 'itemCodigo',                        class:"c-table__header",    cellClass:'c-table__item', filterable: false,},
    { text: 'Descrição',                    value: 'descricao',                         class:"c-table__header",    cellClass:'c-table__item', width:"550"},
    { text: 'Data de Solicitação',          value: 'dataSolicitacaoFormatada',          class:"c-table__header",    cellClass:'c-table__item', },
    { text: 'Data de Liberação Compras',    value: 'dataLiberacaoComprasFormatada',     class:"c-table__header",    cellClass:'c-table__item', },
    { text: 'Data de Necessidade',          value: 'dataNecessidadeFormatada',          class:"c-table__header",    cellClass:'c-table__item', },
    { text: 'Quantidade',                   value: 'quantidade',                        class:"c-table__header",    cellClass:'c-table__item', filterable: false,},
    { text: 'Unidade',                      value: 'unidadeSigla',                      class:"c-table__header",    cellClass:'c-table__item', filterable: false,},
    { text: 'Valor Disponivel',             value: 'valorDisponivel',                   class:"c-table__header",    cellClass:'c-table__item', filterable: false,  width:"150", },
    { text: 'Status',                       value: 'status',                            class:"c-table__header",    cellClass:'c-table__item', filterable: false,},
]

const loadCompradores = async () =>{

    const responseCompradores = await ERP.getManyWithView(View.ORDEM_DE_SERVICO_DISTRIBUICAO_DE_REQUISICAO_DE_COMPRAS_COMPRADORES);
    if(responseCompradores.status != 200){
        throw new Error("Falha ao obter Compradores");
    }

    compradores.value = responseCompradores.data;

};

const loadOrdemDeServicoItens = async () =>{
    ordemDeServicoItensSelecionados.value = [];
    compradorSelecionado.value = {};

    const responseOrdemDeServicoItens = await ERP.getManyWithView(View.ORDEM_DE_SERVICO_DISTRIBUICAO_DE_REQUISICAO_DE_COMPRAS);
    ordemDeServicoItens.value = responseOrdemDeServicoItens.data;

    fillSelectJobs();
    fillSelectOS();
    fillSelectPalavrasChave();
    clearBuscaGeral();

    ordemDeServicoItensLoading.value = false;
};



const fillSelectJobs = () =>{
    jobSelecionado.value = "";
    jobs.value = ordemDeServicoItens.value.map(({jobCodigo})=>jobCodigo);
};

const fillSelectOS = () =>{
    ordemDeServicoSelecionada.value = "";
    ordensDeServico.value = ordemDeServicoItens.value.map(({osCodigo})=>osCodigo);
};

const fillSelectPalavrasChave = () =>{
    palavraChaveSelecionada.value = "";
    palavrasChave.value = ["Teste1","Teste2"];
};

const clearBuscaGeral = () =>{
    buscaGeral.value = "";
};



const aoRetornarItens = async ()=>{

    if(ordemDeServicoItensSelecionados?.value?.length == 0){
        return false;
    }

    retornandoItens.value = true;

}

const aoDecidirRetornarItens = async (decisao)=>{

    if(decisao.resultado == true){

        let ordemDeServicoItens = ordemDeServicoItensSelecionados.value.map(({id}) => {
        
            return{
                id:id,
                status:"LC"
            }
        
        });
        
        let justificativa = `Retornado para LC\nJustificativa:${decisao.justificativa}`;


        let itensRetornadosResponse = await OrdemDeServicoItemService.alterarItens(ordemDeServicoItens,justificativa);
        if(itensRetornadosResponse.status != 200){
            throw new Error("Falha ao retornar os Itens para o Coordenador"); 
        }

    }

    retornandoItens.value = false;
    loadOrdemDeServicoItens();

}

const aoDistribuirItens = async ()=>{

    if(!compradorSelecionado?.value?.id){
        return false;
    }

    if(UtilArray.isEmpty(ordemDeServicoItensSelecionados.value)){
        return false;
    }

    distribuindoItens.value = true;

    let ordemDeServicoItensIDs = ordemDeServicoItensSelecionados.value.map(({id}) => id);

    let requisicoesDeCompraResponse = await RequisicaoDeCompraService.criarRequisicoes(ordemDeServicoItensIDs, compradorSelecionado.value);
    if(requisicoesDeCompraResponse.status != 200){
        throw new Error("Falha ao distribuir as Requisições de Compra"); 
    }

    distribuindoItens.value = false;

    loadOrdemDeServicoItens();

}



onMounted(async ()=>{

   await loadCompradores();
   await loadOrdemDeServicoItens();

});




watch(retornandoItens, (novoValor) => {
    controlesDesativados.value = novoValor;
});

watch(distribuindoItens, (novoValor) => {
    controlesDesativados.value = novoValor;
});


</script>

<template>

    <main 
        class="c-main"
        :class="{ 'c-main--disabled': controlesDesativados }"
    >

        <h2>
            Distribuição de Requisições de Compra
        </h2>

        <v-card>

            <v-card-title
                class="c-table-holder"
            >

                <h3
                    class="c-table__titulo"
                >
                    Itens das Ordens de Serviço
                </h3>

                <div
                    class="c-table__buscas"
                >

                    <v-select
                        label="Job"
                        class="c-busca__job"
                        v-model="jobSelecionado"
                        :items="jobs"
                        :item-props="true"
                        item-text="codigo"
                        hide-details
                        outlined
                        return-object
                        clearable
                        :disabled="controlesDesativados"
                    ></v-select>

                    <v-select
                        label="OS"
                        class="c-busca__os"
                        v-model="ordemDeServicoSelecionada"
                        :items="ordensDeServico"
                        :item-props="true"
                        item-text="codigo"
                        hide-details
                        outlined
                        return-object
                        clearable
                        :disabled="controlesDesativados"
                    ></v-select>

                    <v-select
                        label="Palavras Chaves"
                        class="c-busca__palavraChave"
                        v-model="palavraChaveSelecionada"
                        :items="palavrasChave"
                        :item-props="true"
                        item-text="codigo"
                        hide-details
                        outlined
                        return-object
                        clearable
                        disabled
                    ></v-select>

                    <v-text-field
                        label="Buscar"
                        class="c-busca__geral"
                        v-model="buscaGeral"
                        append-icon="mdi-magnify"
                        single-line
                        hide-details
                        outlined
                        clearable
                        :disabled="controlesDesativados"
                    >
                    </v-text-field>

                </div>

                <div
                    class="c-table__controles"
                >
                
                    <div
                        class="c-controles__compradores"
                    >

                        <v-select
                            label="Comprador"
                            v-model="compradorSelecionado"
                            :items="compradores"
                            :item-props="true"
                            item-text="nome"
                            hide-details
                            outlined
                            return-object
                            :disabled="controlesDesativados"
                        ></v-select>

                    </div>

                    <div
                        class="c-controles__botao-esquerda"
                    >

                        <v-tooltip bottom>

                            <template v-slot:activator="{ on, attrs }">

                                <v-btn
                                    color="primary"
                                    elevation="2"
                                    v-bind="attrs"
                                    v-on="on"
                                    v-on:click="aoRetornarItens"
                                    :disabled="controlesDesativados"
                                    :loading="retornandoItens"
                                >
                                    Retornar
                                    
                                </v-btn>

                            </template>

                            <span>Retornar itens para o Coordenador</span>

                        </v-tooltip>

                    </div>

                    <div
                        class="c-controles__botao-direita"
                    >

                        <v-tooltip bottom>

                            <template v-slot:activator="{ on, attrs }">

                                <v-btn
                                    color="primary"
                                    elevation="2"
                                    v-bind="attrs"
                                    v-on="on"
                                    @click="aoDistribuirItens"
                                    :disabled="controlesDesativados"
                                    :loading="distribuindoItens"
                                >
                                
                                    Distribuir
                                    
                                </v-btn>

                            </template>

                            <span>Distribuir itens para o Comprador</span>

                        </v-tooltip>

                    </div>

                </div>

            </v-card-title>

            <v-data-table
                class="c-table elevation-1"
                v-model="ordemDeServicoItensSelecionados"
                :headers="ordemDeServicoItensHeaders"
                :items="ordemDeServicoItens"
                :search="buscaGeral"
                :items-per-page="-1"
                select-strategy="all"
                item-key="id"
                show-select
                return-object
                :loading="ordemDeServicoItensLoading"
                loading-text="Carregando... Por favor, aguarde."
            >

                <template v-slot:item.descricao="{ item }">

                    <p
                        class="c-cell__descricao"
                    >

                        {{item.descricao}}

                    </p>

                </template>

                <template v-slot:item.valorDisponivel="{ item }">

                    <vuetify-money
                        type="number"
                        v-model="item.valorDisponivel"
                        :readonly=true
                        backgroundColor="transparent"
                        :options="{
                            prefix:'R$',
                            precision:2
                        }"
                    >

                    </vuetify-money>
                    
                </template>
        
            </v-data-table>

        </v-card>

        <RetornarItemModal
            :aberto="retornandoItens"
            @update:aberto="aoDecidirRetornarItens"
        ></RetornarItemModal>

    </main>

</template>

<style scoped>

.c-main{
    display: grid;
    gap: 15px;
}

.c-main--disabled{
    pointer-events: none;
    user-select: none; 
}

.c-main--disabled >>> .c-table__header{
    pointer-events: none;
    user-select: none; 
}

.c-table-holder{
    display: grid; 
    grid-template-columns: 1fr 1fr; 
    grid-template-rows: 1fr auto; 
    grid-template-areas: 
    "titulo vazio"
    "buscas controles";
    gap: 10px;
    align-items: initial;
}

.c-table__title { 
    grid-area: titulo;
}

.c-table__buscas { 
    grid-area: buscas;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr; 
    grid-template-rows: 1fr auto; 
    gap: 10px;
    grid-template-areas: 
        "buscaJob buscaOS buscaPalavraChave"
        "buscaGeral buscaGeral buscaGeral";
}

.c-cell__descricao{
    white-space: normal;
    margin: 0px !important;
}

.c-busca__job{
    grid-area: buscaJob;
}

.c-busca__os{
    grid-area: buscaOS;
}

.c-busca__palavraChave{
    grid-area: buscaPalavraChave;
}

.c-busca__geral{
    grid-area: buscaGeral;
}

.c-table__controles { 
    grid-area: controles;
    display: grid;
    grid-template-areas: 
    "compradores compradores"
    "botao-esquerda botao-direita";
    padding: 0 20px;
    gap: 10px;
}

.c-controles__compradores { 
    grid-area: compradores;
}

.c-controles__botao-esquerda { 
    grid-area: botao-esquerda;
    display: grid;
    grid-auto-flow: column;
}

.c-controles__botao-direita { 
    grid-area: botao-direita;
    display: grid;
    grid-auto-flow: column;
}

.c-table{
    display: grid;
    white-space: nowrap;
}

</style>